// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1IZbf","text":"SelectPayment_text__2H72k","title":"SelectPayment_title__Ic_9l","btn":"SelectPayment_btn__1B3xn"};